import React, { FC, useEffect, useRef, useState } from 'react';
import { myInfoDataStore } from 'src/store/myInfo';
import { dateCalendarFormatType } from 'src/utils/dateSet';
import InputBox from 'src/components/atoms/input/InputBox';
import InputDateBox from 'src/components/atoms/input/InputDateBox';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import _ from 'lodash';
import './style.scss';

interface Props {
  viewType?: string;
}

const MyInfo: FC<Props> = ({ viewType }) => {
  const myInfoDataOrg: any = myInfoDataStore((state: any) => state.result).data || {};
  const myInfoData = _.cloneDeep(myInfoDataOrg);

  const bindMyInfoDataState = myInfoDataStore((state: any) => state.bind);

  const inpRef = useRef<HTMLInputElement | null>(null);
  const calendarStartRef = useRef<HTMLInputElement | null>(null);
  const calendarEndRef = useRef<HTMLInputElement | null>(null);

  const inpChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    myInfoData[key] = e.target?.value || '';
    bindMyInfoDataState({ data: { ...myInfoData } });
  };
  const inpChangeEvent = (e: React.ChangeEvent<HTMLInputElement>) => {};
  const findAdressEvt = () => {};

  // const calendarStartEvt = (date: string) => {
  //   myInfoDataStateResult.data.start_date = date;
  //   bindMyInfoDataState({ data: { ...myInfoDataStateResult.data } });
  // };
  // const calendarEndEvt = (date: string) => {
  //   myInfoDataStateResult.data.end_date = date;
  //   bindMyInfoDataState({ data: { ...myInfoDataStateResult.data } });
  // };

  const labelStyle = {
    color: '#aaa',
    width: '80px',
    fontSize: '12px',
    // border: '1px solid #333',
  };
  const labelStyleT2 = {
    color: '#aaa',
    width: '71px',
    fontSize: '12px',
  };
  const inputStyle = {
    fontSize: '14px',
    lineHeight: '14px',
    fontWeight: '400',
    width: 'calc(100% - 80px)',
  };

  return (
    <div className={['_step_a_my_info', viewType].join(' ')}>
      <div className="_row">
        <div className="_item">
          <InputBox
            changeEvt={e => inpChangeEvent(e)}
            inputRef={inpRef}
            label="성명"
            status="_read"
            labelPosition="left"
            value={myInfoData.name || ''}
            placeholder={viewType !== 'edit' ? '' : 'Insert Input'}
            labelStyleDef={labelStyle}
            styleDef={inputStyle}
          />
        </div>
        <div className="_item">
          <InputBox
            changeEvt={inpChangeEvent}
            inputRef={inpRef}
            label="사번"
            labelPosition="left"
            status="_read"
            value={myInfoData.co_id || ''}
            placeholder={viewType !== 'edit' ? '' : 'Insert Input'}
            labelStyleDef={labelStyle}
            styleDef={inputStyle}
          />
        </div>
        <div className="_item">
          <InputBox
            changeEvt={inpChangeEvent}
            inputRef={inpRef}
            label="재직상태"
            status="_read"
            labelPosition="left"
            value={myInfoData.is_work === 'Y' ? '재직' : '-'}
            placeholder={viewType !== 'edit' ? '' : 'Insert Input'}
            labelStyleDef={labelStyle}
            styleDef={inputStyle}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item">
          <InputBox
            changeEvt={inpChangeEvent}
            inputRef={inpRef}
            label="부서"
            status="_read"
            labelPosition="left"
            // value={inputState.value}
            value={myInfoData.deptname || ''}
            placeholder={viewType !== 'edit' ? '' : ''}
            labelStyleDef={labelStyle}
            styleDef={inputStyle}
          />
        </div>
        <div className="_item">
          <InputBox
            changeEvt={inpChangeEvent}
            inputRef={inpRef}
            label="근무시작"
            status="_read"
            labelPosition="left"
            value={dateCalendarFormatType(myInfoData.start_date || '')}
            placeholder={viewType !== 'edit' ? '' : 'Insert Input'}
            labelStyleDef={labelStyle}
            styleDef={inputStyle}
          />
          {/* <InputDateBox
            inpRef={calendarStartRef}
            value={dateCalendarFormatType(myInfoData.start_date || '')}
            status={viewType !== 'edit' ? '_read' : ''}
            direction="left"
            placeholder="Insert Keyword"
            label="근무시작"
            labelPosition="left"
            labelStyleDef={{
              width: '54px',
              fontSize: '13px',
            }}
            styleDef={{
              width: 'calc(100% - 100px)',
              fontSize: '15px',
              fontWeight: '600',
            }}
            clickCalendarEvt={calendarStartEvt}
          /> */}
        </div>
        <div className="_item">
          <InputBox
            changeEvt={inpChangeEvent}
            inputRef={inpRef}
            label="근무종료"
            status="_read"
            labelPosition="left"
            value={dateCalendarFormatType(myInfoData.end_date || '')}
            placeholder={viewType !== 'edit' ? '' : 'Insert Input'}
            labelStyleDef={labelStyle}
            styleDef={inputStyle}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item">
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'email')}
            inputRef={inpRef}
            label="E-mail"
            status={viewType !== 'edit' ? '_read' : ''}
            labelPosition="left"
            value={myInfoData.email || ''}
            placeholder={viewType !== 'edit' ? '' : 'Insert Input'}
            labelStyleDef={labelStyle}
            styleDef={inputStyle}
          />
        </div>
        <div className="_item">
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'cel_number')}
            inputRef={inpRef}
            label="휴대전화"
            status={viewType !== 'edit' ? '_read' : ''}
            labelPosition="left"
            value={myInfoData.cel_number || ''}
            placeholder={viewType !== 'edit' ? '' : 'Insert Input'}
            labelStyleDef={labelStyle}
            styleDef={inputStyle}
          />
        </div>
        <div className="_item">
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'tel_1')}
            inputRef={inpRef}
            label="사내전화"
            status={viewType !== 'edit' ? '_read' : ''}
            labelPosition="left"
            value={myInfoData.tel_1 || ''}
            placeholder={viewType !== 'edit' ? '' : 'Insert Input'}
            labelStyleDef={labelStyle}
            styleDef={inputStyle}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _row3">
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'add')}
            inputRef={inpRef}
            label="주소"
            status={viewType !== 'edit' ? '_read' : ''}
            labelPosition="left"
            value={myInfoData.add || ''}
            placeholder={viewType !== 'edit' ? '' : 'Insert Input'}
            labelStyleDef={labelStyle}
            styleDef={{ ...inputStyle }}
          />
        </div>
        {viewType !== 'edit' ? (
          ''
        ) : (
          <div className="_item _row3_btn">
            <DefaultButton
              text="도로명주소 검색"
              clickEvent={e => findAdressEvt()}
              icon="ri-home-4-line"
              type="type1"
              styleDef={{
                width: '100%',
                height: '32px',
                fontSize: '12px',
                lineHeight: '10px',
                color: '#555',
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MyInfo;
